(function (window, document) {
  $(document).ready(function () {
    console.log("init");

    const postCardImageLinks = document.querySelectorAll(
      ".post-card"
    );

    postCardImageLinks.forEach(function (postCardImageLink) {
      const postCardImage = postCardImageLink.querySelector(".posty");
      console.log(postCardImage);
      postCardImageLink.addEventListener("mousemove", function (e) {
        var xPos =
          (e.offsetX - postCardImage.offsetWidth / 2) /
          postCardImage.offsetWidth;
        var yPos =
          (e.offsetY - postCardImage.offsetHeight / 2) /
          postCardImage.offsetHeight;

          
        const degrees = 18;
        const scale = 1.03;



        postCardImage.style.transform =
          "translateY(" +
          yPos * degrees +
          "px) translateX(" +
          xPos * degrees +
          "px)";

          if (navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0) 
            {
               postCardImage.style.transition = "border .5s";
      
            } else {
              postCardImage.style.transition = "border .5s, transform 0.08s ease";
            }

        // postCardImage.style.transform =
        //   "rotateX(" +
        //   yPos * degrees +
        //   "deg) rotateY(" +
        //   xPos * -degrees +
        //   "deg) scale(" +
        //   scale +
        //   ", " +
        //   scale +
        //   ")";

        // postCardImage.style.transform =
        //   "rotateY(" + yPos * 80 + "deg) scale(.7, .7)";
      });

      postCardImageLink.addEventListener("mouseout", function () {
        postCardImage.style.transform =
          "translateX(0px) translateY(0px)";

          
          postCardImage.style.transition = "border .5s, transform .5s cubic-bezier(0.335, 0.040, 0.515, 1.280)";

      });
    });
  });
})(window, document);
